import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Stack } from "native-base";
import { isWeb } from "@madmedical/utils";
import BottomNavigation from "../molecules/BottomNavigation";
import useResponsive from "../util/useResponsive";
import { colors } from "../charts/useStyles";
/* const styles = StyleSheet.create({
    safeArea: { backgroundColor: colors.grey50, flex: 1, width: "auto" },
});
 */
const MainLayout = ({ children, bottomNavigation, sidebar }) => {
    const { isSmallScreen } = useResponsive();
    return (_jsx(Box, Object.assign({ backgroundColor: colors.grey50, flex: 1, width: "full", safeArea: true }, { children: _jsxs(Box, Object.assign({ width: "full", 
            // minHeight={isWeb && isSmallScreen ? "100vh" : null}
            height: "100%", background: "gray.50" }, { children: [_jsxs(Stack, Object.assign({ nativeID: "native-base-container", direction: "row", space: {
                        base: 0,
                        md: 2,
                    }, minWidth: "full", minHeight: "full" }, { children: [sidebar && (_jsx(Box, Object.assign({ minHeight: "full", bg: "white", borderColor: "gray.100", borderWidth: 1, borderStyle: "solid", width: 62, borderRadius: "lg", display: {
                                base: "none",
                                md: "flex",
                            } }, { children: sidebar }))), _jsx(Box, Object.assign({ flex: 1, nativeID: "native-content-container" }, { children: children }))] })), isSmallScreen && bottomNavigation && (_jsx(Box, Object.assign({ position: isWeb ? "fixed" : "absolute", bottom: 0, width: "full", justifyContent: "center", alignItems: "center", marginLeft: isWeb ? "-16px" : 0 }, { children: _jsx(BottomNavigation, { navigation: bottomNavigation }) })))] })) })));
};
export default MainLayout;
